import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { Brand, CTA } from './Common';

const links = [['Soluciones', '#seguros'], ['Asistencias', '#asistencias']];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return <header className="site-header campaign-header" data-testid="site-header">
    <div className="nav-inner container"><Brand dark />
      <nav className="desktop-nav" aria-label="Navegación principal">{links.map(([label, href], i) => <a data-testid={`nav-link-${i}`} key={href} href={href}>{label}</a>)}</nav>
      <CTA id="nav-advice-cta" className="cta-small">Asesoría 360°</CTA>
      <button className="mobile-menu-button" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} aria-controls="mobile-navigation" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
    </div>
    <AnimatePresence>{open && <motion.nav id="mobile-navigation" className="mobile-nav" aria-label="Navegación móvil" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
      {links.map(([label, href], i) => <a href={href} key={href} data-testid={`mobile-nav-link-${i}`} onClick={() => setOpen(false)}>{label}<ArrowUpRight size={18} /></a>)}
      <a href="#asesoria" data-testid="mobile-advice-cta" onClick={() => setOpen(false)}>Asesoría 360° gratuita<ArrowUpRight size={18} /></a>
    </motion.nav>}</AnimatePresence>
  </header>;
};